var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-group"},[(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._l((_vm.items),function(item){return _c('button-fill',{key:item,attrs:{"active":item === _vm.value,"label":item,"uppercase":_vm.uppercase},on:{"click":() => _vm.onClick(item)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }